/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 20:11:01
 * @LastEditTime: 2024-11-12 20:21:26
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\enrollPlan\index.tsx
 * @Description: 招生计划列表页
 */
import LabelNone from '@/components/label_none';
import { CommmonGet } from '@/util/network/api';
import { Spin, message } from 'antd';
import { LgPopLayer } from 'lancoo-web-ui';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { selectUserId, setLoginShow } from '../../store/reducers/userInfo';
import AdmissDetail from '../hearder/menuPop/list/enroll/admissDetail';
import AuditDetail from '../hearder/menuPop/list/enroll/auditDetail';
import { OptionFunContext } from './common/publicFunc';
import './index.scss';
import AddOrupEnroll from './list/addOrupEnroll';
import PlanList from './list/planList';
import classNames from 'classnames';
import EnrollDetail from './enrollDetail';


const EnrollPlan = () => {

  const planYear = null

  const service = {
    list: '/portal/homepage/getAllPlans'
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const userId = useSelector(selectUserId);

  const registerRef = useRef<any>(null);
  const registerRef1 = useRef<any>(null);
  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);
  const [onceload, setOnceload] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  // 表格
  const [list, setList] = useState<any[]>([]);
  // 选中信息
  const [selectItem, setSelectItem] = useState<any>({});
  const [visible, setVisible] = useState<boolean>(false);
  // 是否显示取消按钮
  const [cancelFlag, setCancelFlag] = useState<boolean>(true);
  // 确认报名信息
  const [showInfo, setShowInfo] = useState<boolean>(false);

  //显示录取弹窗
  const [enrollVisible, setEnrollVisible] = useState<boolean>(false);

  const optionFun = {
    checkPlan: (item: any) => {
      window.scrollTo(0, 0);
      navigate(`/enrollPlan/details?planId=${item.planId}`);
    },
    changeEnroll: (value: boolean) => {
      setEnrollVisible(value);
    },
    enroll: (item: any, type?: string) => {
      if (!userId && type !== 'priview') {
        dispatch(setLoginShow(true));
        return
      } else {
        if (item?.applyStatus === 1 && item?.enableApply !== 3) {
          optionFun.checkPlan(item);
        } else {
          if (item?.planStatus === 1 && type !== 'details' && item?.enableApply !== 3) {
            window.scrollTo(0, 0);
            navigate(`/enrollPlan/details?planId=${item.planId}`);
          } else {
            setVisible(true);
            setSelectItem(item);
          }
        }
      }
    },
    setSelectItem,
    list
  }

  const getInit = () => {
    setIsloading(true);
    CommmonGet(service.list, { planYear }).then((res: any) => {
      setList(res?.data?.pageList || []);
      if (visible && res?.data?.pageList) {
        setSelectItem(res?.data?.pageList?.find(ele => ele.planId === selectItem.planId) || {})
      }
    }).catch(() => {
    }).finally(() => {
      setIsloading(false);
      setOnceload(true);
    });
  };

  useEffect(() => {
    if (pathname === '/enrollPlan') {
      getInit();
    } else {
      list.length === 0 && getInit();
    }
  }, [pathname]);

  useEffect(() => {
    !visible && setCancelFlag(true);
  }, [visible]);

  useEffect(() => {
    if (showInfo) {
      registerRef1.current.form.setFieldsValue(registerRef.current.form.getFieldsValue() || {});
      registerRef1.current.setavatr(registerRef.current.avatr);
      registerRef1.current.extraform.setFieldsValue(registerRef.current.extraform.getFieldsValue() || {});
    }
  }, [showInfo])

  return (
    <>
      {pathname === '/enrollPlan' && <div className="enrollPlan">
        <Spin spinning={isloading} className='wjz_spin_div'>
          {onceload ?
            list?.length !== 0 ?
              <PlanList list={list} optionFun={optionFun} /> : <LabelNone tips='暂无招生计划' search={false} /> :
            <div></div>
          }
        </Spin>
      </div>}

      <OptionFunContext.Provider value={optionFun}>
        <Outlet key={refreshKey} />
      </OptionFunContext.Provider>

      <LgPopLayer
        title={selectItem?.enableApply === 3 ? `查看${selectItem?.planStatus === 2 ? '审核' : selectItem?.planStatus === 3 ? selectItem?.admissionInfo ? '录取' : '审核' : '报名'}信息` : '报名信息填写'}
        isOpen={visible && !showInfo}
        isCoverLayerClickClose={false}
        onShowLayer={(value: boolean, type: string) => {
          if (type === "onConfirm" && selectItem?.planStatus !== 2 && selectItem?.planStatus !== 3 && cancelFlag) {
            const addOrupEnroll = registerRef.current;
            addOrupEnroll.postData().then(res => {
              setVisible(false);
              if (pathname === '/enrollPlan') {
                getInit();
              } else {
                setRefreshKey(refreshKey + 1);
              }
            }).catch(err => {
              message.destroy()
              err?.msg && err?.type && message[err.type](err.msg);
            })
          } else {
            setVisible(false);
          }
        }}
        width={(selectItem?.planStatus === 2 || selectItem?.planStatus === 3) ? 780 : 1160}
        height={(selectItem?.planStatus === 2 || selectItem?.planStatus === 3) ? 535 : 656}
        needScroll
        // scrollViewPosition={'In'}
        // className='enrollPlan_pop'
        confirmText={(selectItem?.enableApply === 3 && selectItem?.planStatus !== 2 && selectItem?.planStatus !== 3) ? cancelFlag ? '修改' : '确定' : '确定'}
        className={classNames('enrollPlan_pop', { 'wjz_pop_cancelNone': !cancelFlag, 'noShowCancelBtn': selectItem?.planStatus === 3 })}
        isShowBottom={(selectItem?.enableApply === 3 && (selectItem?.planStatus === 2||(selectItem?.planStatus === 3&&selectItem?.admissionInfo)))? false: selectItem?.enableApply !== 3 || cancelFlag? true: false}
      >
        <>
          {visible &&
            (() => {
              switch (selectItem?.planStatus) {
                case 2:
                  return <AuditDetail data={selectItem?.auditInfo?.auditList || []} selectItem={selectItem} setRefreshKey={pathname === '/enrollPlan' ? getInit : setRefreshKey} />
                case 3:
                  return selectItem?.admissionInfo ?
                    <AdmissDetail getInit={getInit} data={selectItem?.admissionInfo? [selectItem?.admissionInfo]: []} selectItem={selectItem} /> :
                    <AuditDetail data={selectItem?.auditInfo?.auditList || []} selectItem={selectItem} setRefreshKey={pathname === '/enrollPlan' ? getInit : setRefreshKey} />
                default:
                  return <AddOrupEnroll
                    ref={registerRef}
                    selectItem={selectItem}
                    setCancelFlag={setCancelFlag}
                    setShowInfo={setShowInfo}
                    preview={!cancelFlag}
                  />
              }
            })()
          }
        </>
      </LgPopLayer>
      <LgPopLayer
        title={'确认报名信息'}
        isOpen={showInfo}
        isCoverLayerClickClose={false}
        onShowLayer={(value: boolean, type: string) => {
          if (type === "onConfirm" && selectItem?.planStatus !== 2 && selectItem?.planStatus !== 3 && cancelFlag) {
            const addOrupEnroll = registerRef1.current;
            addOrupEnroll.postData().then(res => {
              setShowInfo(false);
              setVisible(false);
              if (pathname === '/enrollPlan') {
                getInit();
              } else {
                setRefreshKey(refreshKey + 1);
              }
            }).catch(err => {
              message.destroy()
              err?.msg && err?.type && message[err.type](err.msg);
            })
          } else {
            setShowInfo(false);
          }
        }}
        width={1160}
        height={656}
        needScroll
        // scrollViewPosition={'In'}
        // className='enrollPlan_pop'
        confirmText={'提交申请'}
        closeText={"返回修改"}
        className={classNames('enrollPlan_pop', { 'wjz_pop_cancelNone': !cancelFlag, 'noShowCancelBtn': selectItem?.planStatus === 3 })}
      >
        <>
          {showInfo && <>
            <span style={{
              position: 'fixed',
              bottom: '0px',
              color: 'rgb(255, 75, 75)',
              lineHeight: '56px',
            }}>
              请确认您所提交的报名信息！
            </span>
            <AddOrupEnroll
              ref={registerRef1}
              selectItem={selectItem}
              setCancelFlag={setCancelFlag}
              setShowInfo={setShowInfo}
              preview={true}
            />
          </>}
        </>
      </LgPopLayer>

      <LgPopLayer
        title={"查看录取信息"}
        isOpen={enrollVisible}
        isCoverLayerClickClose={false}
        onShowLayer={(value: boolean, type: string) => {
          setEnrollVisible(!value);
        }}
        width={780}
        height={535}
        needScroll
        className={classNames('enrollPlan_pop', 'noShowCancelBtn')}
        isShowBottom={false}
      >
        <>
          {enrollVisible &&
            (() => <EnrollDetail data={selectItem} admissionInfo={selectItem?.admissionInfo}/>
            )()
          }
        </>
      </LgPopLayer>
    </>
  )
}

export default EnrollPlan
